// 格式化标题长度 21个
export const cutString = (data, number) => {
  number = number || 21
  const newData = data.substring(0, number)
  return newData.length < number ? newData : newData + '…'
}
